import { Autocomplete, TextField, IconButton } from "@material-ui/core"
import LaunchIcon from "@material-ui/icons/Launch"
import InvoyageTooltip from "./bill/InvoyageTooltip"

export default function ClientSelector({isDisabled, handleChange, clients, selectedClient, showLink}) {

  return (

    <Autocomplete
    options={[{name: "No Company Selected", id: null}, ...clients]}
    disabled={isDisabled}
    value={selectedClient}
    onChange={handleChange}
    getOptionLabel={(option) => option.name}
    style={{ width: 300 }}
    renderOption={(props, option) => (
            <div {...props}>
            {option.name}
            </div>
            )}
            renderInput={(params) => (
            <TextField 
                {...params}
                label="Client"
                variant="outlined"
            />
            )}
    /> 
  )
}